/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PlayCircleRegular from './play-circle-regular-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PlayCircleRegular {...validProps} />;
}

SvgComponent.iconName = 'playCircleRegular';

export const PlayCircleRegularIcon = svgIconWrapper(SvgComponent);
